import React from 'react';
import { Link } from 'gatsby';
import ImgHTML from '../../ImgHTML';

const SingleBox = ({ image, heading, description, url }) => {
  return (
    <div className="col-lg-4">
      <div className="single-ib">
        <div className="icon">
          <ImgHTML src={image} alt="get to know us icon" />
        </div>
        <Link to={url} className="name font-weight-bold text-dark">
          {heading}
        </Link>
        <div className="body">{description}</div>
        <Link to={url} className="link">
          Read more
        </Link>
      </div>
    </div>
  );
};

export default SingleBox;
